/* src/app/private/components/view/department-section/create-department/create-department.component.scss */
/*# sourceMappingURL=create-department.component.css.map */
